export default __webpack_public_path__ + "static/media/element_69.5f6531b6.webp";